var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useMemo } from 'react';
import clsx from 'clsx';
import { useClasses, useLayoutProps, useProps, } from '@hawkins/helpers';
import { FormGroupContext } from './formGroup.context';
import { useFormGroupStyles } from './formGroup.styles';
var displayName = 'FormGroup';
/**
 * The Form Group component is a simple component that separates content into distinct groups.
 */
export var FormGroup = forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, props = __rest(_a, ["children"]);
    // Props
    var _c = useProps(displayName, props), classesProp = _c.classes, className = _c.className, _d = _c.component, Component = _d === void 0 ? 'div' : _d, _e = _c.disabled, disabledProp = _e === void 0 ? false : _e, _f = _c.fullWidth, fullWidth = _f === void 0 ? false : _f, gap = _c.gap, layout = _c.layout, _g = _c.orientation, orientation = _g === void 0 ? 'vertical' : _g, styleProp = _c.style, restProps = __rest(_c, ["classes", "className", "component", "disabled", "fullWidth", "gap", "layout", "orientation", "style"]);
    var isHorizontal = orientation === 'horizontal';
    // Read from the form group context, if it is inside a <FormGroup/>
    var formGroupContext = useContext(FormGroupContext);
    var disabled = (formGroupContext === null || formGroupContext === void 0 ? void 0 : formGroupContext.disabled) || disabledProp;
    // Styles
    var baseClasses = useFormGroupStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var topLevelLayoutProps = useMemo(function () { return ({ gap: gap }); }, [gap]);
    var style = useLayoutProps({ layout: layout, style: styleProp, topLevelLayoutProps: topLevelLayoutProps });
    var rootClassName = clsx(classes.HAWKINS_BASE, className, classes.root, (_b = {},
        _b[classes.rootFullWidth] = fullWidth,
        _b[classes.rootHorizontal] = isHorizontal,
        _b[classes.rootVertical] = !isHorizontal,
        _b));
    // Context
    var groupContext = useMemo(function () { return ({ disabled: disabled }); }, [disabled]);
    return (_jsx(FormGroupContext.Provider, __assign({ value: groupContext }, { children: _jsx(Component, __assign({ className: rootClassName, ref: ref, style: style }, restProps, { children: children })) })));
});
FormGroup.displayName = displayName;
